import PermissionControllService from '@/application/services/PermissionControll'
import util from "@/application/libs/util"
import { t } from 'i18next'

const context = {
    reactiveVars: {}
};

const defaultErrorHandler = (message) => () => {
    util.showErrorNotification({ title: message});
};

const hasLoadingProp = function(obj){
    if(obj.data.isLoading){
        return {backgroundColor: "#ffa8a8"};
    } else {
        return null;
    }
};

const _grantAllPermissionToAccessProfile = function() {
    const {selectedProfileID} = context;
    const permissions = AccessProfilePermissionGridConfig.getRowData();
    
    PermissionControllService.grantAllPermissionToAccessProfile(selectedProfileID, permissions).then(() => {
        if(context.selectedProfileID === selectedProfileID){
            AccessProfilePermissionGridConfig.reloadData();
        }
    }).catch(defaultErrorHandler(t('error_saving_permissions')));
};

const grantAllPermissions = () => {
    const selectedRows = AccessProfileGridConfig.advancedOptions.api.getSelectedRows();
    if(selectedRows.length){
        const accessProfile = selectedRows[0];
        util.showConfirmationDialog(context.reactiveVars.$modal, _grantAllPermissionToAccessProfile, 
        t('grant_all_permissions', {PARAM: `${accessProfile.NMPERFILACESSO}` }) );
    } else {
        util.showNotification({ title: t('select_an_access_profile')});
    }
};

const _revokeAllPermissionToAccessProfile = function() {
    const {selectedProfileID} = context;
    const permissions = AccessProfilePermissionGridConfig.getRowData();
    
    PermissionControllService.revokeAllPermissionToAccessProfile(permissions).then(() => {
        if(context.selectedProfileID === selectedProfileID){
            AccessProfilePermissionGridConfig.reloadData();
        }
    }).catch(defaultErrorHandler(t('error_revoking_permissions')));
};

const revokeAllPermissions = () => {
    const selectedRows = AccessProfileGridConfig.advancedOptions.api.getSelectedRows();
    if(selectedRows.length){
        const accessProfile = selectedRows[0];
        util.showConfirmationDialog(context.reactiveVars.$modal, _revokeAllPermissionToAccessProfile, 
        t('revoke_all_permissions', {PARAM: `${accessProfile.NMPERFILACESSO}` }) );
    } else {
        util.showNotification({ title: t('select_an_access_profile')});
    }
};

const showUserByAccessProfile = ({data}) => {
    UsersGridConfiguration.dataSourceFilter.NRPERFILACESSO = data.NRPERFILACESSO;
    context.reactiveVars.$modal.show("userGrid");
};

const changeAccessProfilePermission = function({data, node}){
    const {NROTIMIZADORITEM, ATIVO_key, NROTIMIZADORITEMPER} = data;
    const {selectedProfileID} = context;
    if(ATIVO_key === "S"){
        PermissionControllService.saveAccessProfilePermission(context.selectedProfileID, NROTIMIZADORITEM).
        then((response) => {
            if(selectedProfileID === context.selectedProfileID){
                const newKey = response[0];
                data.NROTIMIZADORITEMPER = newKey;
                data.isLoading = false;
                AccessProfilePermissionGridConfig.updateRowNode({data, node, force: true});
            }
        }).
        catch(defaultErrorHandler(t('error_saving_permission')))
    } else if(ATIVO_key === "N" && NROTIMIZADORITEMPER){
        PermissionControllService.removeAccessProfilePermission(NROTIMIZADORITEMPER).
        then(() => {
            data.isLoading = false;
            AccessProfilePermissionGridConfig.updateRowNode({data, node, force: true});
        }).
        catch(defaultErrorHandler(t('error_saving_permission')));
    }
};

const flipValue = function({data, node}){
    if(!data.isLoading){
        const extractValueFrom = data.ATIVO_key || data.ATIVO;
        data.ATIVO_key = extractValueFrom === 'N' ? 'S' : 'N';
        data.ATIVO = data.ATIVO_key;
        data.isLoading = true;
        AccessProfilePermissionGridConfig.updateRowNode({data, node});
        changeAccessProfilePermission({data, node})
    }
};

const AccessProfileGridConfig = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true
    },
    columnDefs: [
        {
            headerValueGetter: ()=> {return t('access_profile_number') } , field: "NRPERFILACESSO",
        },
        {
            headerValueGetter: ()=> {return t('access_profile') } , field: "NMPERFILACESSO",
        }
    ],
    dataSource: PermissionControllService.getAccessProfiles,
    onRowDoubleClicked: showUserByAccessProfile,
    rowSelection: "single"
};

const checkedRowMap = {
    S: "✓",
    N: ""
};

const IDAtivoCellRenderer = function(params) {
    return params.data.isLoading ? `<div> ... </div>` : `<div> ${checkedRowMap[params.value]} </div>`;
};

const AccessProfilePermissionGridConfig = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true
    },
    columnDefs: [
        {
             headerValueGetter: ()=> {return t('item') } , field: "DSOTIMIZADORITEM", flex: 1,
            cellStyle: function(p) {
                if(p.data.DSOTIMIZADORITEM && !p.data.DSOTIMIZADORITEM.includes('MENU')){
                    return {
                        marginLeft: '40px'
                    };
                } else {
                    return null;
                }
            }
        },
        {
            headerValueGetter: ()=> {return t('active') } , field: "ATIVO",
            editable: false,
            cellEditor: "optionsBunchCellEditor",
            cellClass: ["permission-controll-check-editor"],
            cellRenderer: IDAtivoCellRenderer,
            // valueFormatter: ({ value }) => checkedRowMap[value],
            // onCellDoubleClicked: flipValue,
            onCellClicked: flipValue,
            // cellStyle: hasLoadingProp,
            cellEditorParams: {
                options: checkedRowMap
            },
            filter: false,
            // supressSizeToFit: true
        }
    ],
    // supressAutoSize: true,
    resizeStyle: 'fit',
    dataSource: () => PermissionControllService.getAccessProfilesPermissions(context.selectedProfileID),
    // onCellValueChanged: /*util.debounce(*/changeAccessProfilePermission/*, 1000)*/,
    rowSelection: "disabled"
};

const UsersGridConfiguration = {
    defaultColDef: {
        resizable: true, 
        lockVisible: true, 
        checkboxSelection: false, 
        editable: false,
        sortable: true,
        filter: true
    },
    columnDefs: [
        { headerValueGetter: ()=> {return t('code') } , field: "CDOPERADOR",},
        { headerValueGetter: ()=> {return t('name') } , field: "NMOPERADOR"}
    ],
    dataSource: PermissionControllService.getUsersByAccessProfile,
    rowSelection: "disabled",
    dataSourceFilter: {}
};

export default {
    grantAllPermissions,
    revokeAllPermissions,
    AccessProfileGridConfig,
    AccessProfilePermissionGridConfig,
    UsersGridConfiguration,
    context
}